/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_English_SubtitlesInputs */

const en_ccsl_export_header_english_subtitles = /** @type {(inputs: Ccsl_Export_Header_English_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ENGLISH SUBTITLES`)
};

const fr_ccsl_export_header_english_subtitles = /** @type {(inputs: Ccsl_Export_Header_English_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SOUS-TITRES ANGLAIS`)
};

const de_ccsl_export_header_english_subtitles = /** @type {(inputs: Ccsl_Export_Header_English_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ENGLISCHE UNTERTITEL`)
};

const it_ccsl_export_header_english_subtitles = /** @type {(inputs: Ccsl_Export_Header_English_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SOTTOTITOLI IN INGLESE`)
};

const ru_ccsl_export_header_english_subtitles = /** @type {(inputs: Ccsl_Export_Header_English_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`АНГЛИЙСКИЕ СУБТИТРЫ`)
};

const es_ccsl_export_header_english_subtitles = /** @type {(inputs: Ccsl_Export_Header_English_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SUBTÍTULOS EN INGLÉS`)
};

const zh_cn2_ccsl_export_header_english_subtitles = /** @type {(inputs: Ccsl_Export_Header_English_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`英文字幕`)
};

const ja_ccsl_export_header_english_subtitles = /** @type {(inputs: Ccsl_Export_Header_English_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`英語字幕`)
};

const hi_ccsl_export_header_english_subtitles = /** @type {(inputs: Ccsl_Export_Header_English_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंग्रेजी में उपशीर्षक`)
};

const pt_pt2_ccsl_export_header_english_subtitles = /** @type {(inputs: Ccsl_Export_Header_English_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGENDAS EM INGLÊS`)
};

/**
* | output |
* | --- |
* | "ENGLISH SUBTITLES" |
*
* @param {Ccsl_Export_Header_English_SubtitlesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_english_subtitles = /** @type {((inputs?: Ccsl_Export_Header_English_SubtitlesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_English_SubtitlesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_header_english_subtitles(inputs)
	if (locale === "de") return de_ccsl_export_header_english_subtitles(inputs)
	if (locale === "it") return it_ccsl_export_header_english_subtitles(inputs)
	if (locale === "ru") return ru_ccsl_export_header_english_subtitles(inputs)
	if (locale === "es") return es_ccsl_export_header_english_subtitles(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_header_english_subtitles(inputs)
	if (locale === "ja") return ja_ccsl_export_header_english_subtitles(inputs)
	if (locale === "hi") return hi_ccsl_export_header_english_subtitles(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_header_english_subtitles(inputs)
	return en_ccsl_export_header_english_subtitles(inputs)
});